import { Col as AntCol } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Row } from '@atom/grid/row/row';
import { Text, Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const WrapperStats = styled(AntCol)`
  display: flex;
  flex-direction: row;
  padding-bottom: 4px;
  border-bottom: 1px solid ${ColorEnum.Black10};
`;

export const Col = styled(AntCol)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 1px solid ${ColorEnum.Black10};
  padding: 0 16px !important;

  &:first-child {
    padding-left: 0 !important;
  }

  &:last-child {
    border-right: none;
    padding-right: 0 !important;
  }

  @media (max-width: 900px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 8px 0 0 !important;
    border-bottom: 1px solid ${ColorEnum.Black10};
    border-right: none;

    & ${WrapperStats} {
      border-bottom: none;
    }
  }
`;

export const ButtonNext = styled(Button).attrs({
  type: ButtonTypeEnum.Link,
})`
  padding: 8px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  gap: 4px;
`;

export const TitleStat = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorConsumerCardTitle,
}))``;

export const Value = styled(Title).attrs({
  weight: 400,
  level: 4,
})`
  color: ${(props) => props.theme.Title.colorConsumerCardValue};
`;

export const StatsRow = styled(Row)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;
